<template>
  <tr class="table-row">
    <!-- Each Cell -->
    <td
      v-for="column in grid.columns"
      :key="`${row[rowId]}-${row[rowKey]}-${column.key}`"
      class="b2b-grid__cell lg:table-cell"
      :class="[column.key, column.cssClasses]"
    >
      <div class="b2b-grid__label" v-html="column.label"></div>
      <div class="b2b-grid__content">
        <a v-if="column.key === 'name'" :href="nameLinkUrl" class="underline hover:no-underline">
          <span v-html="row[column.key]"></span>
        </a>
        <div v-else>
          <div v-if="column.key === 'userStatus'">
            <span v-if="row[column.key] === true">Active</span>
            <span v-else class="text-red">Inactive</span>
          </div>
          <span v-else v-html="row[column.key]"></span>
        </div>
      </div>
    </td>
  </tr>
</template>

<script>
export default {
  inject: ['grid'],

  props: {
    row: {
      type: [Object, Array],
      default: () => {},
    },
    rowId: {
      type: String,
      default: 'uid',
    },
    rowKey: {
      type: String,
      default: 'uid',
    },
  },

  data() {
    return {};
  },

  computed: {
    nameLinkUrl() {
      return `./details?user=${this.row.uid}`;
    },
  },

  provide() {
    return {
      item: this,
    };
  },
};
</script>
